<template>
  <div class="h-full">
    <StatusList :activeStatuses="internalState" :showCheckbox="true" />
  </div>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import { StatusList } from "@/Components/Status";

const emit = defineEmits(["apply", "isLoaded"]);

const props = defineProps({
  initialState: { type: Array, default: () => [] },
});

const internalState = ref([...props.initialState]);

const disableApply = computed(() => !internalState.value.length);

onMounted(() => {
  emit("isLoaded");
});

function handleApply() {
  emit("apply", internalState.value);
}

defineExpose({
  showBack: false,
  showApply: true,
  showSearch: false,
  disableApply,
  handleBack: () => {},
  handleApply,
});
</script>
